import { PropsWithChildren } from 'react';

import { SidebarInset, SidebarProvider } from '@/shared/ui/sidebar';

import { AppSidebar } from './app-sidebar';
import { BaseFooter } from './base-footer';

export const SidebarLayout = ({ children }: PropsWithChildren) => {
  return (
    <SidebarProvider>
      <AppSidebar />

      <SidebarInset>
        {children}

        <BaseFooter />
      </SidebarInset>
    </SidebarProvider>
  );
};
